(function () {
	'use strict';

	angular
        .module('app')
        .controller('loginController', loginController);

	loginController.$inject = ['$scope', 'loginService', 'toastr'];

	function loginController($scope, loginService, toastr) {
		/* jshint validthis:true */
		var vm = this;
		vm.logoutMessage = '';
		vm.logoutTitle = '';
	    
		vm.userName = '';
		vm.password = '';
		vm.rememberMe = false;
		vm.loginFailed = false;

		vm.login = login;
		vm.logout = logout;

		function login() {
			vm.loginFailed = false;
			loginService.login({ email: vm.userName, password: vm.password, rememberMe: vm.rememberMe }).then(function (result) {
				if (result.data === true) {
					location.reload();
				} else {
					vm.loginFailed = true;
					vm.password = '';
				}
			});
		}

		function logout($event) {
			if ($event) $event.preventDefault();
			toastr.info(vm.logoutMessage, vm.logoutTitle, { 'preventDuplicates' : true });
			loginService.logout().then(function () {
				location.reload();
			});
			return false;
		}
	}
})();
